import { ComboField } from '@components/Fields/ComboField';
import { DateField } from '@components/Fields/DateField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { MenuItem } from '@material-ui/core';
import { IComboRemetenteWhatsapp } from '@model/RemetenteWhatsapp';
import { IRelatorioCancelamentoFilter } from '@services/Relatorios/CancelamentoService';
import React from 'react';

export type RelatorioCancelamentoFilterProps = {
    filter: IFilter<IRelatorioCancelamentoFilter>
    isLoading: boolean
    remetenteWhatsappCombo: IComboRemetenteWhatsapp
}

export function RelatorioCancelamentoFilter ({ filter, isLoading, remetenteWhatsappCombo }: RelatorioCancelamentoFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={2}>
                    <DateField
                        field={filter.fields.dataCancelamentoDe}
                        label="Data de"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        required
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>
 
                <GridItem xs={2}>
                    <DateField
                        field={filter.fields.dataCancelamentoAte}
                        label="Data até"
                        onEnter={filter.handleFilterRequest}
                        required
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.whatsappEnvio}
                        label="Remetente"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value="">Todos</MenuItem>
                        {
                            remetenteWhatsappCombo.createOptionsWithNumero()
                        }
                    </ComboField>
                </GridItem>
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}